import { Module, Mutation, Action } from 'vuex';
import store from '@/store';
import global from './global';
import viagensService from '@/services/viagens.service';
import { throwError } from 'rxjs';
import { cadastroViagemDB, viagensOfflineDB } from '@/helpers/dexieDb';
import GlobalStore from '@/store/modules/global';
import { StatusViagem } from '@/models/status-viagem.enum';
import { SentidoViagem } from '@/models/sentido-viagem.enum';
import dayjs from 'dayjs';

interface Viagem {
  table: {};
  hasTravelActive: Boolean;
  startVerification: string;
  updateTable: string;
  pageRedirect: string;
  location: Object;
}

export const viagens: Module<Viagem, {}> = {
  namespaced: true,
  state: {
    table: {
      headers: [
        { text: '#ID', align: 'center', value: 'id', sortable: false },
        { text: 'Origem', align: 'center', value: 'origem', sortable: false },
        { text: 'Destino', align: 'center', value: 'destino', sortable: false },
        {
          text: 'Data/Hora',
          align: 'center',
          value: 'dataInicio',
          sortable: false,
        },
        { text: 'Sentido', align: 'center', value: 'sentido', sortable: false },
        { text: 'Status', align: 'center', value: 'status', sortable: false },
        { text: 'Ações', align: 'center', value: 'action', sortable: false },
      ],
      viagens: {
        total: 1,
        itens: [] as any[],
        loading: true,
      },
      notSincronized: {
        headers: [
          { text: '#ID', align: 'center', value: 'id', sortable: false },

          {
            text: 'Origem',
            align: 'center',
            value: 'municipioOrigemNome',
            sortable: false,
          },
          {
            text: 'Destino',
            align: 'center',
            value: 'municipioDestinoNome',
            sortable: false,
          },
          {
            text: 'Data/Hora',
            align: 'center',
            value: 'dataInicio',
            sortable: false,
          },
          {
            text: 'Sentido',
            align: 'center',
            value: 'sentido',
            sortable: false,
          },
          { text: 'Status', align: 'center', value: 'status', sortable: false },
          { text: 'Ações', align: 'center', value: 'action', sortable: false },
        ],
        viagens: {
          total: 1,
          itens: [] as any[],
          loading: false,
        },
      },
      tableOffline: {
        offline: false,
        viagens: {
          total: 1,
          itens: [] as any[],
          loading: false,
        },
      },
    },
    hasTravelActive: false,
    startVerification: '',
    updateTable: '',
    pageRedirect: '',
    location: {},
  },
  mutations: {
    setSearchTravel(state: any, value: any): void {
      state.table.viagens = value;
    },
    setHasTravelActive(state: any, value: boolean): void {
      state.hasTravelActive = value;
    },
    setTravelNotSincronized(state: any, value: any) {
      state.table.notSincronized.viagens.itens = value.filter((v : any) => v.idVeiculo == GlobalStore.user.id);
    },
    setStartVerification(state: any, value: any) {
      state.startVerification = value;
    },
    setUpdateTable(state: any, value: any) {
      state.updateTable = value;
    },
    setPageRedirect(state: any, value: any) {
      state.pageRedirect = value;
    },
    setTableOffline(state: any, value: any) {
      state.table.tableOffline.viagens.itens = value;
    },
  },
  actions: {
  async  SEARCH_TRAVEL({ commit, dispatch, start }: any, travel: any) {
      await commit('setSearchTravel', travel);
    },
    VERIFY({ commit, dispatch, state }: any) {
      viagensService.activeTravel().subscribe(
        (res: any) => {
          const { hasViagemAtiva } = res;
          commit('setHasTravelActive', hasViagemAtiva);
        },
        (error) => {
          throwError(error);
          commit('setHasTravelActive', false);
        }
      );
    },
    VERIFY_GEOLOCATION(
      { commit, dispatch, state }: any,
      statusGeolocation: boolean
    ) {
      commit('setHasTravelActive', statusGeolocation);
    },
    async SAVE_TRAVEL_INDEXDB(
      { commit, dispatch, state }: any,
      travel: any
    ): Promise<any> {
      const viagem = await cadastroViagemDB.cadastroViagem.toArray();

      if (
        travel.status === StatusViagem.FINALIZADA ||
        travel.sentido === SentidoViagem.VOLTA
      ) {
        const verifyViagem = viagem.filter((v) => {
          if (v.status === StatusViagem.FINALIZADA) {
            return v.id === travel.id || v.id === travel.viagemOrigemId;
          }
          if (
            v.status === StatusViagem.INICIADA &&
            v.sentido === SentidoViagem.VOLTA
          ) {
            return v.id === travel.viagemOrigemId;
          }
        });
        if (verifyViagem.length === 0) {
          cadastroViagemDB.cadastroViagem.bulkAdd([travel]);
        }
      } else {
        cadastroViagemDB.cadastroViagem.bulkAdd([travel]);
      }
    },
    async VERIFY_INDEXDB({ commit, dispatch, state }: any): Promise<any> {
      const tripsPending = await cadastroViagemDB.cadastroViagem.toArray();
      const tripsOffline = await viagensOfflineDB.viagens.toArray();
      commit('setTravelNotSincronized', tripsPending);
      commit('setTableOffline', tripsOffline);
    },
    SAVE_TRAVEL_INITIAL({ commit, dispatch, state }: any, travel: any): void {
      viagensService.create(travel).subscribe(
        (res) => {
          GlobalStore.setSnackBar({
            show: true,
            message: 'Viagem cadastrada com sucesso!',
            type: 'success',
          });
          commit('setPageRedirect', travel.dataInicio);
        },
        (error) => {
          throwError(error);
          const travelInitial = state.table.notSincronized.viagens.itens.filter(
            (v: any) => {
              return v.status === StatusViagem.INICIADA;
            }
          );
          if (travelInitial.length === 0) {
            GlobalStore.setSnackBar({
              show: true,
              message:
                'Sua viagem será iniciada, mas ficará pendente de sincronização',
              type: 'warning',
            });
            travel.status = StatusViagem.INICIADA;
            travel.sentido = 'IDA';
            travel.idVeiculo = parseInt(GlobalStore.user.id.toString())
            // this.saveTravelIndexDB(body);
            // this.isLoading = false;
            cadastroViagemDB.cadastroViagem.bulkAdd([travel]);
            commit(
              'setPageRedirect',
              StatusViagem.INICIADA + ' - ' + travel.dataInicio
            );
          } else {
            GlobalStore.setSnackBar({
              show: true,
              message:
                'Existe uma viagem INICIADA, dependente de sincronização',
              type: 'warning',
            });
          }
        }
      );
    },
    SAVE_TRAVEL_FINISH({ commit, dispatch, state }: any, travel: any): void {
      travel.idVeiculo = parseInt(GlobalStore.user.id.toString())
      viagensService
        .finishTravel(
          travel.id,
          travel.dataFim,
          travel.latitude,
          travel.longitude
        )
        .subscribe(
          (res) => {
            GlobalStore.setSnackBar({
              show: true,
              message: 'Viagem Finalizada com sucesso!',
              type: 'success',
            });
            commit('setPageRedirect', travel.id || travel.viagemOrigemId);
          },
          (error) => {
            const verifyViagem =
              state.table.notSincronized.viagens.itens.filter((v: any) => {
                if (v.status === StatusViagem.FINALIZADA) {
                  return v.id === travel.id || v.id === travel.viagemOrigemId;
                }
              });
            if (verifyViagem.length === 0) {
              cadastroViagemDB.cadastroViagem.bulkAdd([travel]);
              viagensOfflineDB.viagens.clear();
              /// ATUALIZANDO LISTA DE VIAGENS OFF
              const updateTable = state.table.tableOffline.viagens.itens.filter(
                (v: any) => {
                  return v.id != travel.id;
                }
              );
              viagensOfflineDB.viagens.bulkAdd(updateTable);

              GlobalStore.setSnackBar({
                show: true,
                message:
                  'Sua viagem será finalizada, mas ficará pendente de sincronização',
                type: 'error',
              });
              commit(
                'setPageRedirect',
                travel.id + ' - ' + travel.dataFim ||
                  travel.viagemOrigemId + ' - ' + travel.dataFim
              );
            }
            commit(
              'setPageRedirect',
              travel.id + ' - ' + travel.dataFim ||
                travel.viagemOrigemId + ' - ' + travel.dataFim
            );
          }
        );
    },
    SAVE_TRAVEL_BACK({ commit, dispatch, state }: any, travel: any): void {
      travel.idVeiculo = parseInt(GlobalStore.user.id.toString())
      const travelInitial = state.table.notSincronized.viagens.itens.filter(
        (v: any) => {
          return v.status === StatusViagem.INICIADA;
        }
      );
      if (travelInitial.length === 0) {
        viagensService.returnTravel(travel).subscribe(
          (res) => {
            GlobalStore.setSnackBar({
              show: true,
              message: 'Viagem de volta Iniciada!',
              type: 'success',
            });
            commit(
              'setPageRedirect',
              travel.viagemOrigemId + ' - ' + travel.dataInicio
            );
          },
          (error) => {
            travel.status = StatusViagem.INICIADA;
            travel.sentido = SentidoViagem.VOLTA;
            throwError(error);
            const verifyViagem =
              state.table.notSincronized.viagens.itens.filter((v: any) => {
                if (
                  v.status === StatusViagem.INICIADA &&
                  v.sentido === SentidoViagem.VOLTA
                ) {
                  return v.id === travel.id || v.id === travel.viagemOrigemId;
                }
              });
            if (verifyViagem.length === 0) {
              cadastroViagemDB.cadastroViagem.bulkAdd([travel]);
              viagensOfflineDB.viagens.delete(travel.idCache);
              GlobalStore.setSnackBar({
                show: true,
                message:
                  'Sua viagem será iniciada, mas ficará pendente de sincronização',
                type: 'error',
              });
              commit('setPageRedirect', travel.viagemOrigemId);
            }
          }
        );
      } else {
        GlobalStore.setSnackBar({
          show: true,
          message: 'Existe uma viagem INICIADA, dependente de sincronização',
          type: 'error',
        });
        commit('setPageRedirect', travel.dataInicio);
      }
    },
    SYNCHRONIZE_TRAVEL_INITIAL({ commit, dispatch, state }: any) {
      
      const travelInitial = state.table.notSincronized.viagens.itens.filter(
        (e: any) => {
          return (
            e.status === StatusViagem.INICIADA &&
            e.sentido === SentidoViagem.IDA && 
            e.idVeiculo == GlobalStore.user.id
          );
        }
      );
      
      if(travelInitial.length > 0){
        const exist = state.table.viagens.itens.some( (v: any) => {
          return v.dataInicio == dayjs(travelInitial[0].dataInicio).format('DD/MM/YYYY HH:mm:ss')
        })
        if (!exist) {
          viagensService.create(travelInitial[0]).subscribe(
            (res) => {
              cadastroViagemDB.cadastroViagem
                .delete(travelInitial[0].idCache)
                .then((res) => {
                  // GlobalStore.setSnackBar({
                  //   show: true,
                  //   message: "Viagem sincronizada com sucesso!",
                  //   type: "success",
                  // });
                  commit(
                    'setUpdateTable',
                    StatusViagem.INICIADA + ' - ' + travelInitial[0].dataInicio
                  );
                });
            },
            (error) => {
              throwError(error);
            }
          );
        }else {
          cadastroViagemDB.cadastroViagem
          .delete(travelInitial[0].idCache)
          .then((res) => {
            console.error('viagem duplicada removida')
          });
        }
  
        }


    },
    SYNCHRONIZE_TRAVEL_FINISH(
      { commit, dispatch, state }: any,
      location: { latitude: string; longitude: string }
    ): void {
      if (state.table.notSincronized.viagens.itens.length > 0) {
        state.table.notSincronized.viagens.itens.forEach((e: any) => {
          if (
            (e.latitude === 0 && e.longitude === 0) ||
            (e.latitude === '' && e.longitude === '')
          ) {
            e.latitude = location.latitude;
            e.longitude = location.longitude;
          }
          if (e.status === StatusViagem.FINALIZADA && e.idVeiculo == GlobalStore.user.id) {
            viagensService
              .finishTravel(e.id, e.dataFim, e.latitude, e.longitude)
              .subscribe(
                (res) => {
                  cadastroViagemDB.cadastroViagem
                    .delete(e.idCache)
                    .then((res) => {
                      // GlobalStore.setSnackBar({
                      //   show: true,
                      //   message: "Viagem Finalizada com sucesso!",
                      //   type: "success",
                      // });
                      commit(
                        'setUpdateTable',
                        StatusViagem.FINALIZADA + ' - ' + e.dataInicio
                      );
                    });
                },
                (erro) => {
                  GlobalStore.setSnackBar({
                    show: true,
                    message: 'Não foi possivel sincronizar',
                    type: 'warning',
                  });
                }
              );
          }
        });
      }
    },
    SYNCHRONIZE_TRAVEL_INITIAL_BACK({ commit, dispatch, state }: any) {
      
      const travelInitialBack = state.table.notSincronized.viagens.itens.filter(
        (e: any) => {
          return (
            e.status === StatusViagem.INICIADA &&
            e.sentido === SentidoViagem.VOLTA &&
            e.idVeiculo == GlobalStore.user.id
          );
        }
      );
      if(travelInitialBack.length > 0){
      const exist = state.table.viagens.itens.some( (v: any) => {

          return v.dataInicio == dayjs(travelInitialBack[0].dataInicio).format('DD/MM/YYYY HH:mm:ss')
        })      
        if (!exist) {
        viagensService.returnTravel(travelInitialBack[0]).subscribe(
          (result) => {
            cadastroViagemDB.cadastroViagem
              .delete(travelInitialBack[0].idCache)
              .then((res) => {
                // GlobalStore.setSnackBar({
                //   show: true,
                //   message: "Viagem de volta Iniciada!",
                //   type: "success",
                // });
              });
            commit(
              'setUpdateTable',
              SentidoViagem.VOLTA + ' - ' + travelInitialBack[0].dataInicio
            );
          },
          (error) => {
            throwError(error);
          }
        );
      } else {
        cadastroViagemDB.cadastroViagem
        .delete(travelInitialBack[0].idCache)
        .then((res) => {
          console.error('viagem duplicada removida')
        });
      }
    }
    },
    SAVE_TRAVEL_TABLE_OFFLINE({ commit, dispatch, state }: any, travel: any) {
      // indexedDB.deleteDatabase("viagens");
      viagensOfflineDB.viagens.clear();
      travel.forEach((e: any) => {
        viagensOfflineDB.viagens.bulkAdd([e]);
      });
      commit('setTableOffline', travel);
    },
  },
};
